/** @format */

import { Box } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { FormikErrors, FormikProps, FormikTouched } from 'formik';
import * as React from 'react';

interface Props {
  label: string;
  formik: FormikProps<any>;
  name: string;
  touched: boolean | FormikTouched<any> | FormikTouched<any>[] | undefined;
  errors:
    | string
    | string[]
    | FormikErrors<any>
    | FormikErrors<any>[]
    | undefined;
}
export default function CsDateTimePicker({
  label,
  formik,
  name,
  touched,
  errors,
}: Props) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DateTimePicker']}>
        <DateTimePicker
          label={label}
          className={errors && 'color_error'}
          {...formik}
          onChange={(newValue) => formik.setFieldValue(name, newValue)}
        />
      </DemoContainer>
      <Box className='errors_gl'>{touched && (errors as React.ReactNode)}</Box>
    </LocalizationProvider>
  );
}
